export default __webpack_public_path__ + "static/media/pause.f723efdf.svg";